"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasScope = hasScope;

function hasScope(scopes, scope) {
  if (!scopes.length) return false; // default if no scopes are passe by the app

  return scopes.filter(function (scp) {
    return scp === scope;
  }).length > 0;
}